import { axiosWithAuth } from "../../helpers";

type completeAdjustmentProps = {
	paidYear: string;
	paidMonth: string;
};

type getAdjustmentListProps = {
	page: number;
	sortBy: { id: string; desc: boolean };
	filters: { [key: string]: any };
} & completeAdjustmentProps;

export const adjustmentsService = {
	getAdjustmentsList,
	addAdjustment,
	editAdjustment,
	deleteAdjustment,
};

const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;
const PAGE_SIZE = 50;

function getAdjustmentsList({
	page,
	paidMonth,
	paidYear,
	filters,
	sortBy,
}: getAdjustmentListProps) {
	const businessUnit =
		filters?.businessUnit?.parent?.name || filters?.businessUnit?.name;

	const businessUnitHierarchy =
		filters?.businessUnit?.parent && filters?.businessUnit?.name;

	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			agent_office: filters?.agentOffice || null,
			agent_name: filters?.agentName || null,
			partner_type: filters?.partnerType?.name || null,
			business_unit: businessUnit,
			business_unit_hierarchy: businessUnitHierarchy,
			category: filters?.category?.name || null,
			sort_type: sortBy?.id ? sortBy?.id : undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
		},
		url: `${RESIDUALS_API_URL}/api/adjustments/${paidYear}/${paidMonth}`,
	};

	return axiosWithAuth(options);
}

function addAdjustment(model) {
	const { paidYear, paidMonth, agentId, amount, category, comment } = model;
	const options = {
		method: "POST",
		data: {
			agent_id: agentId,
			amount,
			category,
			comment: comment ? comment : undefined,
		},
		url: `${RESIDUALS_API_URL}/api/adjustments/${paidYear}/${paidMonth}`,
	};

	return axiosWithAuth(options);
}

function editAdjustment({ model, id }) {
	const { paidYear, paidMonth, agentId, amount, category, comment } = model;
	const options = {
		method: "PUT",
		data: {
			agent_id: agentId,
			amount,
			category: category,
			comment: comment ? comment : undefined,
		},
		url: `${RESIDUALS_API_URL}/api/adjustments/${paidYear}/${paidMonth}/${id}`,
	};

	return axiosWithAuth(options);
}

function deleteAdjustment({ paidYear, paidMonth, adjustmentId }) {
	return axiosWithAuth({
		method: "DELETE",
		url: `${RESIDUALS_API_URL}/api/adjustments/${paidYear}/${paidMonth}/${adjustmentId}`,
	});
}
